export const toastTranslations = {
  fr: {
    paymentSuccess: "Paiement réussi !",
    paymentCanceled: "Paiement annulé",
    subscriptionError: "Erreur d'abonnement",
    signoutSuccess: "Déconnexion réussie",
    signoutError: "Erreur de déconnexion"
  },
  en: {
    paymentSuccess: "Payment successful!",
    paymentCanceled: "Payment canceled",
    subscriptionError: "Subscription error",
    signoutSuccess: "Successfully signed out",
    signoutError: "Sign out error"
  },
  es: {
    paymentSuccess: "¡Pago exitoso!",
    paymentCanceled: "Pago cancelado",
    subscriptionError: "Error de suscripción",
    signoutSuccess: "Sesión cerrada exitosamente",
    signoutError: "Error al cerrar sesión"
  }
};